import React, { useState } from 'react';
import { Button, Steps, message, Input, Modal } from 'antd';
import CustomLayout from '../../layouts/Customlayout';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import jaweb from './Images/LogoJAWEB.jpg';
import './Css/zapier.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Step } = Steps;

export default function Zapier() {
    const { t } = useTranslation();
    const integrationTranslations = t("integration");
  
  const [current, setCurrent] = useState(0);
  const [apiKey] = useState(localStorage.getItem('token') || '');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', description: '' });
  const navigate = useNavigate();

  const steps = [
    {
      title: integrationTranslations.zapierTab.steps[0].title,
      content: (
        <div>
          <p>{integrationTranslations.zapierTab.steps[0].description}</p>
          <Input value={apiKey} readOnly />
        </div>
      ),
    },
    {
      title: integrationTranslations.zapierTab.steps[1].title,
      content: (
        <div>
          <p>{integrationTranslations.zapierTab.steps[1].description}</p>
          <Button href="https://zapier.com/sign-up" target="_blank">
            {integrationTranslations.zapierTab.goToZapier}
          </Button>
        </div>
      ),
    },
    {
      title: integrationTranslations.zapierTab.steps[2].title,
      content: <p>{integrationTranslations.zapierTab.steps[2].description}</p>,
    },
    {
      title: integrationTranslations.zapierTab.steps[3].title,
      content: <p>{integrationTranslations.zapierTab.steps[3].description}</p>,
    },
    {
      title: integrationTranslations.zapierTab.steps[4].title,
      content: <p>{integrationTranslations.zapierTab.steps[4].description}</p>,
    },
  ];

  const showModal = (title, description) => {
    setModalContent({ title, description });
    setIsModalVisible(true);
  };

  const handleCancel = () => setIsModalVisible(false);
  const next = () => setCurrent(current + 1);
  const prev = () => setCurrent(current - 1);

  return (
    <CustomLayout>
      <div className="p-16 mx-auto bg-gradient-to-r from-blue-50 to-white shadow-xl rounded-xl">

        {/* Back Button */}
        <Button
          icon={<ArrowLeftOutlined />}
          className="mb-6 bg-gray-200 hover:bg-gray-300 border-none px-4 py-2 rounded-lg"
          onClick={() => navigate('/user/integration')}
        >
          {integrationTranslations.backToIntegrations}
        </Button>

        <div className='flex-1'>
          <div style={{ padding: '20px' }}>
            <span style={{ fontSize: '17px', fontWeight: 'bold', paddingRight: '10px' }}>
              {integrationTranslations.zapierTab.stepsTitle}
            </span>

            {/* Start of the intro section */}
            <div className='integration-intro' style={{ margin: '30px 0', textAlign: 'center' }}>
              <div className='integration-logos flex justify-center items-center'>
                <img
                  src={jaweb}
                  alt='Jaweb Logo'
                  className='logo-animation'
                  style={{ width: '150px', marginRight: '20px' }}
                />
                <ArrowRightOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
                <img
                  src='https://www.good2gosoftware.com/wp-content/uploads/2023/02/2560px-Zapier_logo.svg_-2048x938.png'
                  alt='Zapier Logo'
                  className='logo-animation'
                  style={{ width: '120px', marginLeft: '20px' }}
                />
              </div>
              <p style={{ marginTop: '20px', fontSize: '16px' }}>
                {integrationTranslations.zapierTab.introNote}
              </p>
              <Button
                size='large'
                href='https://zapier.com/apps/jaweb/integrations'
                target='_blank'
                className='invitation-button'
              >
                {integrationTranslations.zapierTab.getApp}
              </Button>
            </div>
            {/* End of intro section */}

            {/* Triggers & Actions */}
            <div className="triggers-actions" style={{ margin: '30px 0', textAlign: 'center' }}>
              <h3 style={{ fontWeight: 'bold' }}>{integrationTranslations.zapierTab.integrationFeatures}</h3>
              <div className='flex justify-center gap-8'>
                <Button
                  type="primary"
                  onClick={() =>
                    showModal(
                      integrationTranslations.zapierTab.triggerTitle,
                      integrationTranslations.zapierTab.triggerDescription
                    )
                  }
                >
                  {integrationTranslations.zapierTab.triggerTitle}
                </Button>
                <Button
                  type="primary"
                  onClick={() =>
                    showModal(
                      integrationTranslations.zapierTab.actionTitle,
                      integrationTranslations.zapierTab.actionDescription
                    )
                  }
                >
                  {integrationTranslations.zapierTab.actionTitle}
                </Button>
              </div>
            </div>

            <Modal title={modalContent.title} open={isModalVisible} onCancel={handleCancel} footer={null}>
              <p>{modalContent.description}</p>
            </Modal>

            <div style={{ marginTop: '20px' }}>
              <Steps current={current}>
                {steps.map((item, index) => (
                  <Step key={index} title={item.title} />
                ))}
              </Steps>
              <div className="steps-content" style={{ marginTop: '20px' }}>
                {steps[current].content}
              </div>
              <div className="steps-action" style={{ marginTop: '20px' }}>
                {current < steps.length - 1 && (
                  <Button type="primary" onClick={() => next()}>
                    {integrationTranslations.zapierTab.next}
                  </Button>
                )}
                {current === steps.length - 1 && (
                  <Button type="primary" onClick={() => message.success(integrationTranslations.zapierTab.complete)}>
                    {integrationTranslations.zapierTab.done}
                  </Button>
                )}
                {current > 0 && (
                  <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
                    {integrationTranslations.zapierTab.previous}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CustomLayout>
  );
}
